module.exports = __webpack_public_path__ + "static/media/dana.ddbff5bc.svg";